import React from "react";

const PaidStamp = ({ 
  isVisible = false, 
  position = "top-right", 
  size = "medium",
  opacity = 0.8,
  className = ""
}) => {
  if (!isVisible) return null;

  // Size configurations
  const sizeConfig = {
    small: {
      width: "80px",
      height: "auto"
    },
    medium: {
      width: "120px",
      height: "auto"
    },
    large: {
      width: "160px",
      height: "auto"
    }
  };

  // Position configurations for absolute positioning
  const positionConfig = {
    "top-right": "top-4 right-4",
    "top-left": "top-4 left-4",
    "center": "top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2",
    "bottom-right": "bottom-4 right-4",
    "bottom-left": "bottom-4 left-4"
  };

  const config = sizeConfig[size] || sizeConfig.medium;
  const positionClass = positionConfig[position] || positionConfig["top-right"];

  return (
    <div
      className={`
        absolute z-20 ${positionClass} 
        select-none pointer-events-none
        ${className}
      `}
      style={{ 
        opacity: opacity
      }}
    >
      <img
        src="/images/paid.png"
        alt="PAID"
        style={{
          width: config.width,
          height: config.height,
          transform: "rotate(15deg)",
          filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))"
        }}
        className="object-contain"
      />
    </div>
  );
};

export default PaidStamp;